import {NSFunctions} from './utils/functions'
import { NSDateDatetime } from './utils/date_datetime';
import { xCore } from './core';
import { URN as NSURN } from './utils/urn';
import { NSDataTypes } from './utils/data_types';
import { NSDataModelInfo } from './data_model_info';
import { Map as Module_Map } from './map';
import {NSCombos} from './utils/combos'
import {NSGroups} from './groups'

import { NSServerCalls } from './utils/servercalls';
import { NSGeoJson } from './utils/geojson';
import { NSResultsInterface } from './results_interface';
import { NSPageLabels } from './page_labels';
import { NSToolDraw } from './tool_draw';
import { NSFeaturesSelect } from './map_features_select';

export let NSAdvancedSearchQueryInterface = {};

/*
	
*/


NSAdvancedSearchQueryInterface.init = function()
{
    NSAdvancedSearchQueryInterfacePrivate.init();
	
	//this.init = 	function () { return NSAdvancedSearchQueryInterfacePrivate.init.apply( NSAdvancedSearchQueryInterfacePrivate, arguments ); };
	this.f_show =		function () { return NSAdvancedSearchQueryInterfacePrivate.f_show.apply( NSAdvancedSearchQueryInterfacePrivate, arguments ); };

	this.o_comparisons_struct = {};
	this.o_comparisons_struct.f_clear_search_criteria =		function () { return NSAdvancedSearchQueryInterfacePrivate.o_comparisons_struct.f_clear_search_criteria.apply( NSAdvancedSearchQueryInterfacePrivate.o_comparisons_struct, arguments ); };
	this.o_comparisons_struct.f_add_search_criteria =		function () { return NSAdvancedSearchQueryInterfacePrivate.o_comparisons_struct.f_add_search_criteria.apply( NSAdvancedSearchQueryInterfacePrivate.o_comparisons_struct, arguments ); };

	this.o_Execute_Query = {}
	this.o_Execute_Query.f_get_more_results =				function () { return NSAdvancedSearchQueryInterfacePrivate.o_Execute_Query.f_get_more_results.apply( NSAdvancedSearchQueryInterfacePrivate.o_Execute_Query, arguments ); };

	

	window.NSAdvancedSearchQueryInterface = NSAdvancedSearchQueryInterface;
	window.NSAdvancedSearchQueryInterfacePrivate_ = NSAdvancedSearchQueryInterfacePrivate;
}


let NSAdvancedSearchQueryInterfacePrivate = 
{
	private_objs: {
		
		f_init: function()
		{
			this.o_comparison_type.f_init();
		},
		
		settings: null, // settings from config

		b_initialization_part_2_executed: false,

		o_as_state: null,	// old xCore.state.advancedQuery
		
		e_div_advanced_search_query: null,
		e_div_advanced_search_query_background: null,
		e_div_advanced_search_query_button_close: null,
		
		e_button_advanced_search_query_close: null,
		
		e_div_advanced_search_form: null,
		e_div_advanced_search_form_selection: null,
		e_sel_geo_area: null,
		e_text_span: null,
		e_geo_span: null,
		e_button_execute_query: null,
		e_span_as_query_messages: null,
		
		o_combo_group: null,
		o_combo_table: null,
		
		e_input_use_geo: null,
		o_combo_geo_field: null,
		o_combo_geo_area: null,
		
		o_combo_pagination_elems: null,
		
		
		//objects:
		o_comparison_type: {
			f_init: function()
			{
				this.a_desc_base = [this.CONSTS.greater_than.desc, this.CONSTS.less_than.desc, this.CONSTS.equal.desc, this.CONSTS.greater_than_or_equal.desc, this.CONSTS.less_than_or_equal.desc, this.CONSTS.is_null.desc, this.CONSTS.is_not_null.desc];
				this.a_key_base = [this.CONSTS.greater_than.key, this.CONSTS.less_than.key, this.CONSTS.equal.key, this.CONSTS.greater_than_or_equal.key, this.CONSTS.less_than_or_equal.key, this.CONSTS.is_null.key, this.CONSTS.is_not_null.key];
				
				this.a_desc_string = [this.CONSTS.equal.desc, this.CONSTS.matches.desc, this.CONSTS.is_null.desc, this.CONSTS.is_not_null.desc];
				this.a_key_string = [this.CONSTS.equal.key, this.CONSTS.matches.key, this.CONSTS.is_null.key, this.CONSTS.is_not_null.key];
			},
			f_get_a_desc: function(s_data_type)
			{				
				if(NSDataTypes.f_type_is_any_text_type(s_data_type))
				{
					return this.a_desc_string;
				}
				else
				{
					return this.a_desc_base;
				}
			},
			f_get_a_key: function(s_data_type)
			{				
				if(NSDataTypes.f_type_is_any_text_type(s_data_type))
				{
					return this.a_key_string;
				}
				else
				{
					return this.a_key_base;
				}
			},
			f_bool_comparison_type_needs_value: function (s_comparison_type_key)
			{
				var b_res = ( s_comparison_type_key != this.CONSTS.is_null.key 
					&& s_comparison_type_key != this.CONSTS.is_not_null.key )? true : false;
				
				return b_res;
			},
			
			
			CONSTS: 
			{
				greater_than: {desc: " > ", key: ">"},
				less_than: {desc: " < ", key: "<"},
				equal: {desc: " = ", key: "="},
				matches: {desc: " contém ", key: "match"},
				is_null: {desc: " nulo ", key: "is_null"},
				is_not_null: {desc: " não nulo ", key: "is_not_null"},
				greater_than_or_equal: {desc: " >= ", key: ">="},
				less_than_or_equal: {desc: " <= ", key: "<="},
			},
			a_desc_base: null,
			a_key_base: null,
			a_desc_string: null,
			a_key_string: null,
			
		},
		
		o_comparison_objects: {
			a_comparisson_objects: [],	//[Objs.ComparisonStruture]
			
			f_get_cmp_struct_by_id: function (s_id)
			{
				var a = this.a_comparisson_objects;
				for(var i=0; i<a.length; i++ )
				{
					var o_i = a[i];
					if(o_i.id == s_id)
					{
						return o_i;
					}
				}
			
			}
		}
		
	},
	
	init: function()
	{
		var private_objs = this.private_objs;
		private_objs.e_div_asearch_holder = document.getElementById(private_objs.s_e_div_asearch_holder_id);
		
		var moduleName = "NSAdvancedSearchQueryInterface";
        private_objs.settings = xCore.modules[moduleName].settings;
		
		/*
		private_objs.f_init();
		
		this.f_create_page_html();
		
		this.o_comparisons_struct.f_init_advanced_query();
		*/
	},

	init_part_2: function()
	{
		let private_objs = this.private_objs;
		private_objs.f_init();
		
		this.f_create_page_html();
		
		this.o_comparisons_struct.f_init_advanced_query();
		
	},
	
	f_create_page_html: function()
	{
		let this_ = this;
		
		let private_objs = this.private_objs;
		
		let s_label_advanced_search = 									NSPageLabels.f_get_label_text_by_internal_name("advanced_search_title");
		let s_label_advanced_search_layer = 							NSPageLabels.f_get_label_text_by_internal_name("advanced_search_layer");
		let s_label_advanced_search_table = 							NSPageLabels.f_get_label_text_by_internal_name("advanced_search_table");
		let s_label_advanced_search_geometry = 							NSPageLabels.f_get_label_text_by_internal_name("advanced_search_geometry");
		let s_label_advanced_search_button_clean_criteria_tool_tip =	NSPageLabels.f_get_label_text_by_internal_name("advanced_search_button_clean_criteria_tool_tip");
		let s_label_advanced_search_button_close_tool_tip = 			NSPageLabels.f_get_label_text_by_internal_name("advanced_search_button_close_tool_tip");

		let s_button_clear_criteria_id = "button_clear_criteria";
		
		let s_html = `
			<div id="div_advanced_search_query">
				<div id="div_advanced_search_query_background"></div>
				<div id="div_advanced_search_query_content">
					<div id="div_advanced_search_query_header">
						<div id="div_advanced_search_query_title">${s_label_advanced_search}</div>
						<div id="div_advanced_search_query_button_close">
							<button id="button_advanced_search_query_close" type="button" class="btn btn-sm" title="${s_label_advanced_search_button_close_tool_tip}"><img src="${xCore.application.images_base_path}/common/x-lg.svg" ></button>
						</div>
					</div>
					<div id="div_advanced_search_form" class="d-flex flex-column gap-2">
						<div id="div_advanced_search_form_selection" class="d-flex flex-column gap-2">
							<div class="row gy-2 align-items-center">
								<div class="col-12 col-sm-6 col-md-6">
									<div class="advanced-search-input">
										<div class="advanced-search-input-title">${s_label_advanced_search_layer}</div>
										<div class="advanced-search-input-content">
											<select id="sel_group" class="form-select form-select-sm"></select>
										</div>
									</div>
								</div>
								<div class="col-12 col-sm-6 col-md-6">
									<div class="advanced-search-input">
										<div class="advanced-search-input-title">${s_label_advanced_search_table}</div>
										<div class="advanced-search-input-content">
											<select id="sel_table" class="form-select form-select-sm"></select>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div id="div_advanced_search_form_geo" class="d-flex flex-column gap-2">
							<div class="row gy-2 align-items-center">
								<div class="col-12">
									<div class="advanced-search-input">
										<div class="advanced-search-input-title">${s_label_advanced_search_geometry}</div>
										<div class="advanced-search-input-content">
											<div class="row gy-2 align-items-center">
												<div class="col-12 col-sm-6 col-md-4">
													<select id="sel_geo_field" class="form-select form-select-sm"></select>
												</div>
												<div class="col-12 col-sm-5 col-md-2">
													<select id="sel_geo_area" class="form-select form-select-sm"></select>
												</div>
												<div class="col-1">
													<input class="form-check-input" type="checkbox" id="input_use_geo">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<hr>
						<div id="div_advanced_search_form_execution">
							<div class="row gy-2 align-items-center">
								<div class="col-12">
									<div class="advanced-search-input">
										<div class="advanced-search-input-title">Critérios</div>
										<div class="advanced-search-input-content">
											<div class="row gy-2 align-items-center">
												<div class="col-10 col-md-6">
													<div id="div_searchConditions">
														<span id="text_span"></span>
														<span id="geo_span"></span>
													</div>
												</div>
												<div class="col-2 col-md-1">
													<button id="${s_button_clear_criteria_id}" type="button" class="btn btn-sm btn-default" title="${s_label_advanced_search_button_clean_criteria_tool_tip}" >
														<img src="${xCore.application.images_base_path}/common/eraser-fill.svg" aria-hidden="true">
													</button>
												</div>
												<div class="col-10 col-md-4">
													<div class="d-flex align-items-center gap-2">
														<span id="span_sel_pagination_elems_asq"># / pag.</span>
														<select id="sel_pagination_elems_asq" class="form-select form-select-sm"></select>
													</div>
												</div>
												<div class="col-2 col-md-1">
													<button id="button_execute_query" type="button" class="btn btn-sm btn-outline-secondary"><img src="${xCore.application.images_base_path}/common/check-lg.svg" aria-hidden="true"></button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div>
							<span id="span_as_query_messages" class=""></span>
						</div>
					</div>
				</div>
			</div>
		`;
		
		var e_body = document.getElementsByTagName("body")[0];
		NSFunctions.f_dom_elem_append_dom_childs_by_html(e_body, s_html);

		{
			//init elements events
			let elem = document.getElementById(s_button_clear_criteria_id);
			elem.onclick = function()
			{
				NSAdvancedSearchQueryInterface.o_comparisons_struct.f_clear_search_criteria();
			}

		}
		
		private_objs.e_div_advanced_search_query = document.getElementById("div_advanced_search_query");
		private_objs.e_div_advanced_search_query_background = document.getElementById("div_advanced_search_query_background");
		private_objs.e_div_advanced_search_query_button_close = document.getElementById("div_advanced_search_query_button_close");
		
		private_objs.e_button_advanced_search_query_close = document.getElementById("button_advanced_search_query_close");
		
		
		var e_div_advanced_search_form = document.getElementById("div_advanced_search_form");
		private_objs.e_div_advanced_search_form = e_div_advanced_search_form;
		
		var e_div_advanced_search_form_selection = document.getElementById("div_advanced_search_form_selection");
		private_objs.e_div_advanced_search_form_selection = e_div_advanced_search_form_selection;

		var e_sel_geo_area = document.getElementById("sel_geo_area");
		private_objs.e_sel_geo_area = e_sel_geo_area;
		
		var e_text_span = document.getElementById("text_span");
		private_objs.e_text_span = e_text_span;
		
		var e_geo_span = document.getElementById("geo_span");
		private_objs.e_geo_span = e_geo_span;
		
		var e_button_execute_query = document.getElementById("button_execute_query");
		private_objs.e_button_execute_query = e_button_execute_query;
		
		e_button_execute_query.onclick = function(){this_.o_Execute_Query.f_execute();};
		
		var e_span_as_query_messages = document.getElementById("span_as_query_messages");
		private_objs.e_span_as_query_messages = e_span_as_query_messages;
		
		
		//ids used in above html string:
		var s_id_sel_dataset = "sel_dataset";
		var s_id_sel_group = "sel_group";
		var s_id_sel_table = "sel_table";
		
		
		
		this.f_hide();
		
		private_objs.e_div_advanced_search_query_background.onclick = function(){  this_.f_button_close_click(); };
		private_objs.e_button_advanced_search_query_close.onclick = function(){  this_.f_button_close_click(); };
		
		
		this.o_geo_struct.f_initialize();
		
		this.o_pagination_strut.f_initialize();
		
		this.combos.f_initialize_combos(s_id_sel_dataset, s_id_sel_group, s_id_sel_table);
		
		
		
	},
	
	f_show: function()
	{
		
		if( ! this.private_objs.b_initialization_part_2_executed )
		{
			this.init_part_2();
			this.private_objs.b_initialization_part_2_executed = true;
		}
		
		var e_div_advanced_search_query = this.private_objs.e_div_advanced_search_query;
		var e_div_advanced_search_query_background = this.private_objs.e_div_advanced_search_query_background;
		var e_div_advanced_search_query_button_close = this.private_objs.e_div_advanced_search_query_button_close;
		
		e_div_advanced_search_query.style.display = '';
		e_div_advanced_search_query_background.style.display = '';
		
		e_div_advanced_search_query_button_close.style.display = '';//e_div_advanced_search_query_button_close.style.display = 'none';//e_div_advanced_search_query_button_close.style.display = '';
		
	},
	f_hide: function()
	{
		var e_div_advanced_search_query = this.private_objs.e_div_advanced_search_query;
		var e_div_advanced_search_query_background = this.private_objs.e_div_advanced_search_query_background;
		var e_div_advanced_search_query_button_close = this.private_objs.e_div_advanced_search_query_button_close;
		
		e_div_advanced_search_query.style.display = 'none';
		e_div_advanced_search_query_background.style.display = 'none';
		e_div_advanced_search_query_button_close.style.display = 'none';
		
	},
	f_is_visible: function()
	{
		var e_div_advanced_search_query = this.private_objs.e_div_advanced_search_query;
		
		var b_visible = (e_div_advanced_search_query.style.display == 'none')? false : true;
		
		return b_visible;
		
	},
	f_button_close_click: function()
	{
		this.f_hide();
	},
	
	
	f_execute_query_button_set_state: function (b_active)
	{
		var private_objs = this.private_objs;
		
		var e_button_execute_query = private_objs.e_button_execute_query;
		
		if( b_active)
		{
			e_button_execute_query.removeAttribute("disabled");
		}
		else
		{
			e_button_execute_query.setAttribute("disabled", "disabled");
		}
		
		
	},
	f_execute_query_button_get_state: function()
	{
		var private_objs = this.private_objs;
		
		var e_button_execute_query = private_objs.e_button_execute_query;
		var b_active = (e_button_execute_query.getAttribute("disabled") == "disabled") ? false : true;
		
		return b_active;
	},
	
	/*
	-------------------------------------------------------------------------------------------------------------------------
	Structs:
	*/
	o_comparisons_struct : 
	{
		private_objs:
		{
			e_div_and_or: null,
			e_criteria_and_or_select: null,
			e_criteria_field: null,
			e_criteria_operator: null,
			e_criteria_value_input: null,
			e_criteria_value_select: null
		},

		f_comparison_add: function ()
		{
			var this_ = this;
			var private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var private_objs_local = this.private_objs;
//			var e_div_base = private_objs_global.e_div_base;
			var e_div_advanced_search_form = private_objs_global.e_div_advanced_search_form;
			var e_div_advanced_search_form_selection = private_objs_global.e_div_advanced_search_form_selection;
			
			var s_id =  NSFunctions.guidGenerator();
			/*
			var s_id_sel_field = "sel_field_" + s_id;
			var s_id_sel_comparison_type = "sel_comparison_type_" + s_id;
			var s_id_input_value = "input_value_" + s_id;
			var s_id_sel_value = "sel_value_" + s_id;
			
			var i_comparisson_number = private_objs_global.o_comparison_objects.a_comparisson_objects.length + 1;
			*/

			
			let s_label_advanced_search_condition = 						NSPageLabels.f_get_label_text_by_internal_name("advanced_search_condition");
			let s_label_advanced_search_button_add_condition_tool_tip = 	NSPageLabels.f_get_label_text_by_internal_name("advanced_search_button_add_condition_tool_tip");
			let s_label_advanced_search_criteria_and_or_combobox_and = 	NSPageLabels.f_get_label_text_by_internal_name("advanced_search_criteria_and_or_combobox_and");
			let s_label_advanced_search_criteria_and_or_combobox_or = 	NSPageLabels.f_get_label_text_by_internal_name("advanced_search_criteria_and_or_combobox_or");

			let s_button_add_criteria_id = "button_add_criteria";

			let s_html_comparison_set = `
				<div class="row gy-2 aling-items-center">
					<div class="col-12">
						<div class="advanced-search-input">
							<div class="advanced-search-input-title">${s_label_advanced_search_condition}</div>
							<div class="advanced-search-input-content">
								<div class="row gy-2 align-items-center">
									<div class="col-12 col-sm-6 col-md-2" id="div_and_or">
										<select id="criteria_and_or_select" class="form-select form-select-sm">
											<option value="AND">${s_label_advanced_search_criteria_and_or_combobox_and}</option>
											<option value="OR">${s_label_advanced_search_criteria_and_or_combobox_or}</option>
										</select>
									</div>
									<div class="col-12 col-sm-6 col-md-4">
										<select id="criteria_field" class="form-select form-select-sm"></select>
									</div>
									<div class="col-12 col-sm-6 col-md-2">
										<select id="criteria_operator" class="form-select form-select-sm"></select>
									</div>
									<div class="col-12 col-sm-6 col-md-2">
										<input type="text" class="form-control form-control-sm" id="criteria_value_input" >
										<select id="criteria_value_select" class="form-select form-select-sm"></select>
									</div>
									<div class="col col-md-1 d-flex justify-content-end">
										<button id="${s_button_add_criteria_id}" type="button" class="btn btn-sm btn-outline-secondary " title="${s_label_advanced_search_button_add_condition_tool_tip}" >
											<img src="${xCore.application.images_base_path}/common/plus-lg.svg" aria-hidden="true">
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			`;
			
			var s_id_sel_field = "criteria_field";
			var s_id_sel_comparison_type = "criteria_operator";
			var s_id_input_value = "criteria_value_input";
			var s_id_sel_value = "criteria_value_select";
			
			//appending new comparison section
			NSFunctions.f_dom_elem_append_dom_childs_by_html(e_div_advanced_search_form_selection, s_html_comparison_set);		

			
			{
				// init onclick events:
				let elem = document.getElementById(s_button_add_criteria_id);
				elem.onclick = function()
				{
					NSAdvancedSearchQueryInterface.o_comparisons_struct.f_add_search_criteria();
				}
			}

			var e_div_and_or = document.getElementById("div_and_or");
			private_objs_local.e_div_and_or = e_div_and_or;

			var e_criteria_and_or_select = document.getElementById("criteria_and_or_select");
			private_objs_local.e_criteria_and_or_select = e_criteria_and_or_select;
			
			var e_criteria_field = document.getElementById("criteria_field");
			private_objs_local.e_criteria_field = e_criteria_field;

			var e_criteria_operator = document.getElementById("criteria_operator");
			private_objs_local.e_criteria_operator = e_criteria_operator;

			var e_criteria_value_input = document.getElementById("criteria_value_input");
			private_objs_local.e_criteria_value_input = e_criteria_value_input;

			var e_criteria_value_select = document.getElementById("criteria_value_select");
			private_objs_local.e_criteria_value_select = e_criteria_value_select;

			
			var f_onSelect_field_CB = function(s_key)
			{
				this_.f_onSelect_field(s_key, s_id);
			}
			var f_onSelect_comparison_type_CB = function(s_key)
			{
				this_.f_onSelect_comparison_type(s_key, s_id);
			}
			var f_onSelect_catalogue_value_CB = function(s_key)
			{
				this_.f_onSelect_catalogue_value(s_key, s_id);
			}
			
			var o_combo_field = new NSCombos.objs.Combo(s_id_sel_field, f_onSelect_field_CB, [], null);
			var o_combo_comparison_type =  new NSCombos.objs.Combo(s_id_sel_comparison_type, f_onSelect_comparison_type_CB, [], null);
			var e_input_value = document.getElementById(s_id_input_value);
			var o_combo_catalogue_value = new NSCombos.objs.Combo(s_id_sel_value, f_onSelect_catalogue_value_CB, [], null);
			var e_select_catalogue_value = document.getElementById(o_combo_catalogue_value.id_select);
			e_select_catalogue_value.style.display = "none";
			
			var o_in = {
				id: s_id,
				o_combo_field: o_combo_field,
				o_combo_comparison_type: o_combo_comparison_type,
				e_input_value: e_input_value,
				o_combo_catalogue_value: o_combo_catalogue_value,				
			};
			
			var o_cmp_stuct = new NSAdvancedSearchQueryInterfacePrivate.objs.ComparisonStruture(o_in);
			
			private_objs_global.o_comparison_objects.a_comparisson_objects.push(o_cmp_stuct);
			
			
		},
		f_init_advanced_query : function(){

			let private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			let o_combo_table = private_objs_global.o_combo_table;
			let s_schema_table_internal_names = o_combo_table.getSelectedKey();
			
			private_objs_global.o_as_state = { 
				collection : s_schema_table_internal_names,
				parameters : []
			};
		},
		f_add_search_criteria: function(){
			let private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			let private_objs_local = this.private_objs;
			let o_as_state = private_objs_global.o_as_state;
			var criteria_field = private_objs_local.e_criteria_field ;					// select
			var criteria_operator = private_objs_local.e_criteria_operator;				// select
			var criteria_value_input = private_objs_local.e_criteria_value_input;
			var criteria_value_select = private_objs_local.e_criteria_value_select;
			var e_div_and_or = private_objs_local.e_div_and_or;
			var criteria_and_or_select = private_objs_local.e_criteria_and_or_select;
			var criteria_value = null;

			let s_select_criteria_field_key_value = NSCombos.get_select_SelectedKey(criteria_field);
			let s_select_criteria_field_desc_value = NSCombos.get_select_SelectedDesc(criteria_field);
			let s_select_criteria_operator_key_value = NSCombos.get_select_SelectedKey(criteria_operator);
			let s_select_criteria_operator_desc_value = NSCombos.get_select_SelectedDesc(criteria_operator);
			let s_criteria_and_or_select_key_value = NSCombos.get_select_SelectedKey(criteria_and_or_select);
			let s_criteria_and_or_select_desc_value = NSCombos.get_select_SelectedDesc(criteria_and_or_select);
			

			if( criteria_value_input.style.display != "none" ){
				criteria_value = criteria_value_input.value;
			}
			else if( criteria_value_select.style.display != "none" ){
				criteria_value = NSCombos.get_select_SelectedKey( criteria_value_select );
			}

			let s_schema_table_internal_names = NSAdvancedSearchQueryInterfacePrivate.private_objs.o_combo_table.getSelectedKey();
			let a_schema_table = s_schema_table_internal_names.split(NSAdvancedSearchQueryInterfacePrivate.combos.private_objs.CONSTS.COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR);
			let s_schema_internal_name = a_schema_table[0];
			let s_table_internal_name = a_schema_table[1];
			let s_field_internal_name = s_select_criteria_field_key_value;
			let o_field_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
			
			let datatype = NSDataTypes.CONSTS.Types.text;
			if( o_field_info)
				datatype = o_field_info.data_type;

			var aParameter = {
				field :  s_select_criteria_field_key_value,
				operator : s_select_criteria_operator_key_value,
				value :  criteria_value,
				type: datatype
			}

			var criteriaString = s_select_criteria_field_desc_value + " " +  s_select_criteria_operator_desc_value;
			
			if( criteria_value )
				criteriaString += " " + criteria_value;
			
			if ( o_as_state.parameters.length > 0 ){
					aParameter.and_or = s_criteria_and_or_select_key_value;
					criteriaString = " " + s_criteria_and_or_select_desc_value + " " + criteriaString;
			}
			
			if( !this.f_is_parameter_in( aParameter ) ){
				
				o_as_state.parameters.push( aParameter );
					
					/*
					$("#div_and_or").css("display" , "block")
					$("#text_span").append( criteriaString );
					*/
					e_div_and_or.style.display = "block";
					private_objs_global.e_text_span.innerHTML += criteriaString;
			}
		},
		f_is_parameter_in :function( someParameter){
			let private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			let o_as_state = private_objs_global.o_as_state;

			var exists = false;
			for( var i = 0 ; i < o_as_state.parameters.length ; i++){
				let aParameter = o_as_state.parameters[i];
				if( aParameter.field == someParameter.field && 
					aParameter.operator == someParameter.operator && 
					aParameter.value == someParameter.value ){
						exists = true;
					}
			}
			
			return exists;
		},
		f_clear_search_criteria: function(){
			let private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			let private_objs_local = this.private_objs;
			/*
			$("#div_and_or").css("display" , "none")
			$("#text_span").html("");
			$("#geo_span").html("");
			*/
			private_objs_local.e_div_and_or.style.display = "none"
			private_objs_global.e_text_span.innerHTML = "";
			private_objs_global.e_geo_span.innerHTML = "";
			this.f_init_advanced_query();
		},
		f_comparison_remove: function ()
		{
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			var a_comparisson_objects = private_objs.o_comparison_objects.a_comparisson_objects;
			var i_last = a_comparisson_objects.length - 1;
			var o_cmp_stuct = a_comparisson_objects[i_last];
			a_comparisson_objects.splice(i_last,1);//removing last element of the array (original array is changed by splice method)
			
			var e_select_field = document.getElementById(o_cmp_stuct.o_combo_field.id_select);
			var e_select_comparison_type = document.getElementById(o_cmp_stuct.o_combo_comparison_type.id_select);

			var e_row =	e_select_field.closest('.advanced-search-input').closest('.row');
			e_row.parentElement.removeChild(e_row);
			
		},
		f_comparison_remove_all: function ()
		{
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			var a_comparisson_objects = private_objs.o_comparison_objects.a_comparisson_objects;
			while(a_comparisson_objects.length > 0)
			{
				this.f_comparison_remove();
			}
		},
		
		f_onSelect_field: function(s_key, s_id)
		{
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			let s_schema_table_internal_names = private_objs.o_combo_table.getSelectedKey(); //collection
		
			if(s_key != " ")
			{
				let a_schema_table = s_schema_table_internal_names.split(NSAdvancedSearchQueryInterfacePrivate.combos.private_objs.CONSTS.COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR);
				let s_schema_internal_name = a_schema_table[0];
				let s_table_internal_name = a_schema_table[1];
				let s_field_internal_name = s_key;
				let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);

				let a_cmp_desc = private_objs.o_comparison_type.f_get_a_desc(o_field_info_i.data_type);
				let a_cmp_key = private_objs.o_comparison_type.f_get_a_key(o_field_info_i.data_type);
				
				let o_cmp_stuct = private_objs.o_comparison_objects.f_get_cmp_struct_by_id(s_id); //[Objs.ComparisonStruture]
				let o_combo_comparison_type = o_cmp_stuct.o_combo_comparison_type;
				o_combo_comparison_type.reset(a_cmp_desc, a_cmp_key);

				let o_combo_field = o_cmp_stuct.o_combo_field;
				let e_input_value = o_cmp_stuct.e_input_value;
				let o_combo_catalogue_value = o_cmp_stuct.o_combo_catalogue_value;
				let e_select_catalogue_value = document.getElementById(o_combo_catalogue_value.id_select);
				
				e_input_value.removeAttribute("placeholder");
				e_input_value.removeAttribute("step");
				
				
				let b_is_catalogue = (o_field_info_i.is_enum != null)? o_field_info_i.is_enum : false;
				if(b_is_catalogue)
				{
					var a_catalogue_values = o_field_info_i.a_enumerator_values;
					o_combo_catalogue_value.reset(a_catalogue_values, null);
					
					
				}
				else
				{
					if( NSDataTypes.f_type_is_date_or_datetime(o_field_info_i.data_type) )
					{
						e_input_value.setAttribute("type", "date");
						
						var b_type_date_is_supported = NSFunctions.f_check_input_type_date_support();
						if(!b_type_date_is_supported)
						{
							e_input_value.setAttribute("placeholder", "yyyy-mm-dd");
						}
						
					}
					else if(NSDataTypes.f_type_is_any_number_type(o_field_info_i.data_type))
					{
						e_input_value.setAttribute("type", "number");
						var s_number_type;
						if(NSDataTypes.f_type_is_integer_number(o_field_info_i.data_type))
						{
							var s_step = "1";
							e_input_value.setAttribute("step", s_step);
							s_number_type="integer";
						}
						else
						{
							var s_step = "0.000000001";
							e_input_value.setAttribute("step", s_step);
							s_number_type="number";
						}

						var b_type_number_is_supported = NSFunctions.f_check_input_type_number_support();

						e_input_value.setAttribute("placeholder", s_number_type);
						
					}
					else 
					{
						e_input_value.setAttribute("type", "text");
						e_input_value.setAttribute("placeholder", "");
					}
				}
				
				//setting visibility:
				this.f_show_hide_comparion_value(s_id);
			}

		},
		
		f_show_hide_comparion_value: function (s_id)
		{
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			var o_cmp_stuct = private_objs.o_comparison_objects.f_get_cmp_struct_by_id(s_id); //[Objs.ComparisonStruture]
			var o_combo_comparison_type = o_cmp_stuct.o_combo_comparison_type;
			var o_combo_field = o_cmp_stuct.o_combo_field;
			var e_input_value = o_cmp_stuct.e_input_value;
			var o_combo_catalogue_value = o_cmp_stuct.o_combo_catalogue_value;
			var e_select_catalogue_value = document.getElementById(o_combo_catalogue_value.id_select);
			
			//internal names:
			let s_schema_table_internal_names = private_objs.o_combo_table.getSelectedKey(); //collection
			let a_schema_table = s_schema_table_internal_names.split(NSAdvancedSearchQueryInterfacePrivate.combos.private_objs.CONSTS.COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR);
			let s_schema_internal_name = a_schema_table[0];
			let s_table_internal_name = a_schema_table[1];

			var s_field_internal_name = o_combo_field.getSelectedKey(); //field

			let o_table_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
			
			let s_comparison_type_key = o_combo_comparison_type.getSelectedKey();
			let b_comparison_type_needs_value = private_objs.o_comparison_type.f_bool_comparison_type_needs_value(s_comparison_type_key);
			
			if(b_comparison_type_needs_value)
			{
				let b_is_catalogue = (o_table_info!=null)? o_table_info.is_enum : false;
				if(b_is_catalogue)
				{
					//setting visibility
					e_select_catalogue_value.style.display = "";
					e_input_value.style.display = "none";
				}
				else
				{
					//setting visibility
					e_select_catalogue_value.style.display = "none";
					e_input_value.style.display = "";
				}
			}
			else
			{
				e_select_catalogue_value.style.display = "none";
				e_input_value.style.display = "none";
			}
		
		},
		
		f_onSelect_comparison_type: function(s_key, s_id)
		{
			this.f_show_hide_comparion_value(s_id);
			
		},
		f_onSelect_catalogue_value: function(s_key, s_id)
		{
		
		}
	
	},
	
	combos : 
	{
		private_objs: 
		{
			CONSTS:{
				COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR : "____SEP____"
			}
		},

		f_get_CONST_COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR: function()
		{
			return this.private_objs.CONSTS.COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR;
		},
		
		f_initialize_combos: function(s_id_sel_dataset, s_id_sel_group, s_id_sel_table)
		{
			var this_ = this;
			
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var o_sort = NSAdvancedSearchQueryInterfacePrivate.o_sort;
			
			
			var f_onSelect_groupn_CB = function(s_key)
			{
				this_.f_onSelect_group(s_key, s_id_sel_table);
			}
			
			private_objs.o_combo_group =  new NSCombos.objs.Combo(s_id_sel_group, f_onSelect_groupn_CB, [], null);
			
			/* array is automatically sorted */
			var a_groups_for_SEARCH = NSGroups.f_get_groups____for_SEARCH();
			
			var a_group = a_groups_for_SEARCH;
			
			var a_group_desc = [];
			var a_group_key = []
			a_group.forEach(function(o_i,i,a_){
				a_group_desc.push(o_i.external_name);
				a_group_key.push(o_i.external_name);
			});
			
			var a_group_desc_sorted = a_group_desc;
			var a_group_key_sorted = a_group_key;
			private_objs.o_combo_group.reset(a_group_desc_sorted, a_group_key_sorted);
	
			
		},

		f_onSelect_group: function(s_key, s_id_sel_table)
		{
			var this_ = this;
			
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var o_sort = NSAdvancedSearchQueryInterfacePrivate.o_sort;
			
			var s_selected_group = private_objs.o_combo_group.getSelectedKey(); //selected group
			
			var f_onSelect_collection_CB = function(s_key)
			{
				this_.f_onSelect_collection(s_key);
			}

			
			private_objs.o_combo_table =  new NSCombos.objs.Combo(s_id_sel_table, f_onSelect_collection_CB, [], null);
			
			
			
			var s_group_external_name = s_selected_group;

			var a_ft_col = NSGroups.f_get_collections_by_group_for____SEARCH(s_group_external_name);
			var a_col = a_ft_col;
			
			// load all group tables data model info
			let a_s_table_urn = [];
			a_col.forEach(function(o_i,i,a_){
				let s_schema_i = o_i.data_set_internal_name;
				let s_table_internal_name_i = o_i.collection_internal_name;
				let s_table_urn_i = NSURN.f_create_table_urn(s_schema_i, s_table_internal_name_i);
				a_s_table_urn.push(s_table_urn_i);
				
			});

			NSDataModelInfo.f_load_table_list____returning_promise(
				{
					a_s_table_urn: a_s_table_urn,
					b_full_info: false
				}
			).then((a_values) => {
				//console.log("---------- advanced_search_query_interface - just called f_load_table_list____returning_promise");
				//console.log("---------- tables loaded: " + a_s_table_urn.toString() );
				
				
				var a_col_desc = [];
				var a_col_key = []
				a_col.forEach(function(o_i,i,a_){
					let s_schema_i = o_i.data_set_internal_name;
					let s_table_internal_name_i = o_i.collection_internal_name;
					let o_table_info = NSDataModelInfo.f_get_table_info(s_schema_i, s_table_internal_name_i);

					a_col_desc.push(o_table_info.external_name);
					a_col_key.push(s_schema_i + this_.private_objs.CONSTS.COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR 
						+ s_table_internal_name_i ); // ex: municipio____SEP____arvore
				});
				
				var b_int = false;
				var a_key_in = a_col_key;
				var a_desc_in = a_col_desc;

				var o_res_a_key_a_desc = o_sort.f_sort_array_key__and__array_desc(a_key_in, a_desc_in, b_int);
				var a_col_key_sorted = o_res_a_key_a_desc.a_key;
				var a_col_desc_sorted = o_res_a_key_a_desc.a_desc;
				
				private_objs.o_combo_table.reset(a_col_desc_sorted, a_col_key_sorted);
			})
			.catch(error => {
				console.error(error.message);
				console.log(error);
			});
			
			
		},
		f_onSelect_collection: function(s_key)
		{
			var this_ = this;
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var o_comparisons_struct = NSAdvancedSearchQueryInterfacePrivate.o_comparisons_struct;


			let a_key = s_key.split(this.private_objs.CONSTS.COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR);
			let s_schema = a_key[0];
			let s_table = a_key[1];
			let s_table_urn = NSURN.f_create_table_urn(s_schema, s_table);
			
			o_comparisons_struct.f_comparison_remove_all();
			
			var f_cb = function()
			{
				this_.f_onSelect_collection_part_2( s_table_urn );
			}
			

			let o_promise = NSDataModelInfo.f_load_table____returning_promise({			
				b_full_info: true,
				s_table_urn: s_table_urn
			});

			o_promise
			.then(function(b_error, s_message) 
			{
				f_cb();
			})
			.catch(err => { 
				console.log(err);

			});

			
		},
		f_onSelect_collection_part_2: function( s_table_urn )
		{
			let private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			let o_sort = NSAdvancedSearchQueryInterfacePrivate.o_sort;
			let o_comparisons_struct = NSAdvancedSearchQueryInterfacePrivate.o_comparisons_struct;
			let o_geo_struct = NSAdvancedSearchQueryInterfacePrivate.o_geo_struct;
			
			
			let s_schema_internal_name = NSURN.f_get_urn_schema_name(s_table_urn);
			let s_table_internal_name = NSURN.f_get_urn_table_name(s_table_urn);
			
			//NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);

			o_comparisons_struct.f_comparison_add();
			
			let a_field_key = [];
			let a_field_desc = [];
			let a_geo_field_key = [];
			let a_geo_field_desc = [];
			
			a_field_key.push(" ");
			a_field_desc.push(" ");

			let o_collection_schema_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);
			let a_properties_keys = o_collection_schema_info.extra.a_ordered_visible_columns;

			for (let i=0; i<a_properties_keys.length; i++)
			{
				let s_field_key_i = a_properties_keys[i];
				let s_field_i_internal_name = s_field_key_i;
				let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_i_internal_name);
                let s_field_i_internal_name_db = o_field_info_i.internal_name_db;
				let s_field_i_external_name = o_field_info_i.external_name;
				let b_field_is_join_field = o_field_info_i.is_join;


				if (!b_field_is_join_field && !(NSDataTypes.f_type_is_geometry(o_field_info_i.data_type)) )
				{
					a_field_key.push(s_field_i_internal_name);
					a_field_desc.push(s_field_i_external_name);
				}
				else if(NSDataTypes.f_type_is_geometry(o_field_info_i.data_type))
				{
					if(s_field_i_external_name != "Anotação")
					{
						a_geo_field_key.push(s_field_i_internal_name);
						a_geo_field_desc.push(s_field_i_external_name);
					}
				}
			}
			//-------------------------------------------------------------
			//sort arrays:
			let b_int = false;
			
			//regular data:
			let a_key_in = a_field_key;
			let a_desc_in = a_field_desc;
			/*
			returns: {a_key, a_desc}
			*/
			let o_res_a_key_a_desc = o_sort.f_sort_array_key__and__array_desc(a_key_in, a_desc_in, b_int);
			let a_field_key_sorted = o_res_a_key_a_desc.a_key;
			let a_field_desc_sorted = o_res_a_key_a_desc.a_desc;
			
			//geometric data:
			a_key_in = a_geo_field_key;
			a_desc_in = a_geo_field_desc;
			/*
			returns: {a_key, a_desc}
			*/
			o_res_a_key_a_desc = o_sort.f_sort_array_key__and__array_desc(a_key_in, a_desc_in, b_int);
			let a_geo_field_key_sorted = o_res_a_key_a_desc.a_key;
			let a_geo_field_desc_sorted = o_res_a_key_a_desc.a_desc;
			//-------------------------------------------------------------

			//comparison type combos
			var s_field_type = "none has been selected";
			var a_cmp_desc = private_objs.o_comparison_type.f_get_a_desc(s_field_type);
			var a_cmp_key = private_objs.o_comparison_type.f_get_a_key(s_field_type);

			var o_cmp_stuct = private_objs.o_comparison_objects.a_comparisson_objects[0]; 
			var o_combo_field = o_cmp_stuct.o_combo_field;
			var o_combo_comparison_type = o_cmp_stuct.o_combo_comparison_type;
			
			o_combo_field.reset(a_field_desc_sorted, a_field_key_sorted);
			o_combo_comparison_type.reset(a_cmp_desc, a_cmp_key);
			
			
			
			o_geo_struct.f_fill_combo_geo_field(a_geo_field_desc_sorted, a_geo_field_key_sorted);
			
			NSAdvancedSearchQueryInterfacePrivate.o_comparisons_struct.f_init_advanced_query();

		}
	
	},
	
	
	
	o_Execute_Query: 
	{
		private_objs: {
			o_last_request_executed:
			{
				options: {}
			
			},
		},
		f_execute: function()
		{			
			let private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			let o_as_state = private_objs_global.o_as_state;
			let o_message_struct = NSAdvancedSearchQueryInterfacePrivate.o_message_struct;
			let o_geo_struct = NSAdvancedSearchQueryInterfacePrivate.o_geo_struct;
			let this_ = this;
			
			//is the button active?
			if(NSAdvancedSearchQueryInterfacePrivate.f_execute_query_button_get_state() == false)
			{
				return;
			}
			
			o_message_struct.f_clean_message();

			
			if(!this.f_all_input_is_valid())
			{
				return;
			}
			
			//block buttons:
			var b_active = false;
			NSAdvancedSearchQueryInterfacePrivate.f_execute_query_button_set_state(b_active);
			
			
//			NSAdvancedSearchResultsInterface.o_pagination_strut.f_block_buttons();
			
			let o_combo_table = private_objs_global.o_combo_table;
			let s_schema_table_internal_names = o_combo_table.getSelectedKey();
			let a_schema_table = s_schema_table_internal_names.split(NSAdvancedSearchQueryInterfacePrivate.combos.private_objs.CONSTS.COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR);
			let s_schema_internal_name = a_schema_table[0];
			let s_table_internal_name = a_schema_table[1];
			let s_table_urn = NSURN.f_create_table_urn(s_schema_internal_name, s_table_internal_name)
			let o_col_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);


			/* o_as_options_input example:
			{
				"table_urn": "urn__SEP__table__SEP__municipio__SEP__arvore",
				"condition_params": [
					{"column_internal_name": "id", "value": "10000", "operator": ">", "logical_operator": null}, 
					{"column_internal_name": "id", "value": "1000000000000", "operator": "<", "logical_operator": "and"}
					],
				"geometry": {
					"column_internal_name": "geometria",
					"value": "{\"type\":\"Polygon\",\"coordinates\":[[[-1049177.4708982694, 4678065.734341598], [-1048030.9154739918, 4678065.734341598], [-1048030.9154739918, 4678545.854425515], [-1049177.4708982694, 4678545.854425515], [-1049177.4708982694, 4678065.734341598]]]}"
				},
				"limit": 21,
				"offset": 0
			}
			*/
			let o_as_options_input =
			{
				"table_urn": s_table_urn,
				"condition_params": []
			};

			//condition_params
			if( o_as_state.parameters.length > 0)
			{

				for( var i = 0 ; i < o_as_state.parameters.length ; i++ )
				{
					let aParameter = o_as_state.parameters[i];
					
					//var s_clause = (b_first_condition_in_clause)? " WHERE " : " AND "
						 
					let s_field_internal_name = aParameter.field;
					let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);		
					let s_field_data_type = (o_field_info_i!=null)? o_field_info_i.data_type : null;
					let b_is_catalogue = o_field_info_i.is_enum;
					let s_value = aParameter.value;
					
					//if field is filled
					if(s_field_internal_name != " ")
					{
						var s_value_formated;
						var s_field_prop_datatype;
						if(NSDataTypes.f_type_is_any_text_type(s_field_data_type))
						{
							//s_value_formated = '"' + s_value + '"';
							s_value_formated = s_value;
						}
						else if( NSDataTypes.f_type_is_date_or_datetime(s_field_data_type) )
						{
							//"dd-mm-yyyy"
							s_value_formated = NSDateDatetime.NSDate.f_get_fe_s_value_as_db_date_string(s_value);
						}
						else if(b_is_catalogue)
						{
							//s_value_formated = '"' + s_value + '"';
							s_value_formated = s_value; //"enumerator" is just a string
						}
						else
						{
							s_value_formated = s_value;
						}
						s_value_formated+=""; // values are allways passed as string

						let s_operator = aParameter.operator;
						let s_logical_operator = (aParameter.and_or != "")? aParameter.and_or : null;
						let o_condition_param =
							{"column_internal_name": s_field_internal_name, "value": s_value_formated, "operator": s_operator, "logical_operator": s_logical_operator};
						o_as_options_input.condition_params.push(o_condition_param);
					}
				}
			}

			let e_input_use_geo = private_objs_global.e_input_use_geo;
			let o_combo_geo_field = private_objs_global.o_combo_geo_field;
			let o_combo_geo_area = private_objs_global.o_combo_geo_area;
			if(e_input_use_geo.checked == true)
			{
				if(true || o_combo_geo_field.a_elems_keys && o_combo_geo_field.a_elems_keys.length>0)
				{
					let s_area_key = o_combo_geo_area.getSelectedKey();
					let s_field_key = o_combo_geo_field.getSelectedKey();// actually the key is a desc...
					let s_field_geo_internal_name = s_field_key;
	
					let o_gj_feature;
					if(s_area_key == o_geo_struct.CONSTS.Geo_Area.trail.key)
					{
						o_gj_feature = NSToolDraw_.f_get_drawn_geometry_as_geo_json_feature();
					}
					else
					{
						o_gj_feature = Module_Map.f_get_map_bounds_as_geo_json_feature();
					}
					let o_field_geo_value = ( o_gj_feature != null )? o_gj_feature.geometry : null;
					let s_o_field_geo_value = ( o_field_geo_value != null )? JSON.stringify(o_field_geo_value) : null;
					//setting geometry object
					o_as_options_input["geometry"] = {
						"column_internal_name": s_field_geo_internal_name,
						"value": s_o_field_geo_value
					};
				}
				
			}
			
			let i_feature_start = 0;
			let i_constant_max_count = NSAdvancedSearchQueryInterfacePrivate.o_pagination_strut.f_get_i_constant_max_count();

			o_as_options_input["limit"] = i_constant_max_count;
			o_as_options_input["offset"] = i_feature_start;

			let f_cb_error = function (o_resp)
			{
				//unblocking / releasing buttons
				var b_active = true;
				NSAdvancedSearchQueryInterfacePrivate.f_execute_query_button_set_state(b_active);
				
//				NSAdvancedSearchResultsInterface.o_pagination_strut.f_unblock_buttons();
				
				NSResultsInterface.f_clean_results_interface();

				var s_message = "Error executing service."
				NSAdvancedSearchQueryInterfacePrivate.o_message_struct.f_show_message(s_message);

				console.log(s_message);
				if(o_resp != null)
				{
					console.log(o_resp);
				}

			}

			let f_cb_success = function (o_resp)
			{
				//adding property for pagination purposes
				o_resp.feature_start = i_feature_start;
				//unblocking / releasing buttons
				var b_active = true;
				NSAdvancedSearchQueryInterfacePrivate.f_execute_query_button_set_state(b_active);
				
//				NSAdvancedSearchResultsInterface.o_pagination_strut.f_unblock_buttons();

				if(o_resp.success)
				{
					let a_geojson_feature = this_.f_get_service_data_as_geojson_feature_array(o_resp, s_table_urn);
					let o_in = 
					{
						a_table: [
							{
								s_table_urn: s_table_urn,
								a_geojson_feature: a_geojson_feature
							}
						],
						
						b_enable_export: true,
						b_use_pagination: true,
						b_get_more_results_response: false,
						i_feature_limit: i_constant_max_count,
						i_feature_total_count: o_resp.total_count,
						i_feature_offset: 0,
						f_get_more_results: function(o_get_more_results_in) { return this_.f_get_more_results(o_get_more_results_in); }
					};
					/*
						o_in:
						{
							a_table, -> [{ s_table_urn, a_geojson_feature }]  

							b_enable_export
							b_use_pagination
							b_get_more_results_response		-> this call is the f_get_more_results response
							i_feature_limit					-> total results in db (not necessarily the returned count)
							i_feature_total_count			-> total results in db (not necessarily the returned count)
							i_feature_offset				-> offset of first feature in result (start) -> value is 0 based
							f_get_more_results				-> function to call to get more results (pagination)
															->	f_get_more_results(o_get_more_results_in)
															-> 		o_get_more_results_in = {
																		i_feature_offset,
																		i_feature_limit
																	}
							
						}
	
						ex: 
						{
							a_table: [{s_table_urn: "urn__SEP__table__SEP__municipio__SEP__arvore_intervencao", a_geojson_feature: []}]
						}
					*/
					NSResultsInterface.f_reset_results_interface(o_in);
					NSAdvancedSearchQueryInterfacePrivate.f_hide();
					NSFeaturesSelect.f_clear();
				}
				else
				{
					f_cb_error(o_resp);
				}
				
			}
			


			this.private_objs.o_last_request_executed.options = o_as_options_input;

			let o_promise_res = NSServerCalls.f_advanced_search(o_as_options_input);

			o_promise_res
			.then(f_cb_success)
			.catch(f_cb_error);

		},
		
		/*
			o_in = {
				i_feature_offset,
				i_feature_limit
			}
		*/
		f_get_more_results: function(o_in)
		{
			let this_ = this;
			var i_feature_offset = o_in.i_feature_offset;
			var i_feature_limit = o_in.i_feature_limit;
		
			//alert("f_get_more_results!");
			//is the button active?
			if(NSAdvancedSearchQueryInterfacePrivate.f_execute_query_button_get_state() == false)
			{
				return;
			}
			var b_active = false;
			NSAdvancedSearchQueryInterfacePrivate.f_execute_query_button_set_state(b_active);

			var options = this.private_objs.o_last_request_executed.options;
			
			if(i_feature_limit != null)
			{
				var o_new = {}
				var o_ = options;
				var a_k = Object.keys(o_);
				for(var i=0; i<a_k.length; i++)
				{
					var s_k = a_k[i]
					o_new[s_k] = o_[s_k];
				}
				options = o_new;
				options.limit = i_feature_limit;
			}
			
			options.offset = i_feature_offset;

			let s_table_urn = options.table_urn;
			
			
			let f_cb_error_ = function(o_resp)
			{
				var b_active = true;
				NSAdvancedSearchQueryInterfacePrivate.f_execute_query_button_set_state(b_active);

//				NSResultsInterface.f_clean_results_interface();

				var s_message = "Error executing service."
				NSAdvancedSearchQueryInterfacePrivate.o_message_struct.f_show_message(s_message);

				console.log(s_message);
				if(o_resp != null)
				{
					console.log(o_resp);
				}

			}

			let f_cb_success_ = function(o_resp)
			{
				var b_active = true;
				NSAdvancedSearchQueryInterfacePrivate.f_execute_query_button_set_state(b_active);

				if(o_resp.success)
				{
					let a_geojson_feature = this_.f_get_service_data_as_geojson_feature_array(o_resp, s_table_urn);
					let o_in = 
					{
						a_table: [
							{
								s_table_urn: s_table_urn,
								a_geojson_feature: a_geojson_feature
							}
						],
	
						b_enable_export: true,
						b_use_pagination: true,
						b_get_more_results_response: true,
						i_feature_offset: i_feature_offset
						//,f_get_more_results: (o_get_more_results_in) => { this_.f_get_more_results(o_get_more_results_in); } -> already passed on first call
					};
					/*
						o_in:
						{
							a_table, -> [{ s_table_urn, a_geojson_feature }]  

							b_enable_export
							b_use_pagination
							b_get_more_results_response		-> this call is the f_get_more_results response
							i_feature_limit					-> total results in db (not necessarily the returned count)
							i_feature_total_count			-> total results in db (not necessarily the returned count)
							i_feature_offset				-> offset of first feature in result (start) -> value is 0 based
							f_get_more_results				-> function to call to get more results (pagination) -> should only be passed on firest call
															->	f_get_more_results(o_get_more_results_in)
															-> 		o_get_more_results_in = {
																		i_feature_offset,
																		i_feature_limit
																	}
							
						}
	
						ex: 
						{
							a_table: [{s_table_urn: "urn__SEP__table__SEP__municipio__SEP__arvore_intervencao", a_geojson_feature: []}]
						}
					*/
					NSResultsInterface.f_reset_results_interface(o_in);
				}
				else
				{
					f_cb_error_(o_resp);
				}

			}


			let o_promise_res = NSServerCalls.f_advanced_search(options);

			o_promise_res
			.then(f_cb_success_)
			.catch(f_cb_error_);
			
			
		
		}, 

		f_get_service_data_as_geojson_feature_array: function(o_resp, s_table_urn)
		{
			let a_geojson_feature = [];

			let s_schema_internal_name = NSURN.f_get_urn_schema_name(s_table_urn);
			let s_table_internal_name = NSURN.f_get_urn_table_name(s_table_urn);
			let o_col_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);

			let a_column_internal_names = o_resp.column_internal_names;
			let rows = o_resp.rows;

			rows.forEach((o_row_i) =>
			{
				let a_row_values = o_row_i.values;
				let o_geo_json_feature = NSGeoJson.f_get_empty_geojson_feature();
				let b_first_row_geometry_not_found_yet = true; // AQUIIIIIIIIIIIIIII TODO TO DO HOW TO KNOW WHICH IS TABLE PRIMARY GEOMETRY?
				for(let j=0; j<a_row_values.length; j++)
				{
					let o_value_j =a_row_values[j];
					let s_column_internal_name_j = a_column_internal_names[j];
					let o_field_info = NSDataModelInfo.f_get_field_info_by_field_internal_name_db(s_schema_internal_name, s_table_internal_name, s_column_internal_name_j);
					let b_field_is_geometry = NSDataTypes.f_type_is_geometry(o_field_info.data_type);

					if(b_field_is_geometry)
					{
						let o_geometry_value = ( o_value_j != null && o_value_j != "" )? JSON.parse(o_value_j) : null;
						if(b_first_row_geometry_not_found_yet)
						{
							o_geo_json_feature.geometry= o_geometry_value;
							o_geo_json_feature.geometry_name = s_column_internal_name_j;
							o_geo_json_feature.properties[s_column_internal_name_j] = o_geometry_value;
							b_first_row_geometry_not_found_yet = false;
						}
						else
						{
							o_geo_json_feature.properties[s_column_internal_name_j] = o_geometry_value;
						}
						

					}
					else
					{
						o_geo_json_feature.properties[s_column_internal_name_j] = o_value_j;
					}

				}

				//NSResultsInterfacePrivate expects the following id
				o_geo_json_feature["id"] = s_table_internal_name + "." + o_geo_json_feature.properties.id;
				a_geojson_feature.push(o_geo_json_feature);



			});
			
			return a_geojson_feature;


		},
		
		f_s_is_number: function (s)
		{
			var b_res = (isNaN(s) || s=="" )? false: true;
			return b_res;
		},
		
		f_s_is_int: function (s)
		{
			var b_res = (isNaN(s) || s.indexOf(".")>-1 || s=="" )? false: true;
			return b_res;
		},
		
		f_all_input_is_valid: function ()
		{
			var private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var o_geo_struct = NSAdvancedSearchQueryInterfacePrivate.o_geo_struct;
			var o_message_struct = NSAdvancedSearchQueryInterfacePrivate.o_message_struct;
			
			var b_all_input_is_valid =  true;
			var s_error_message = "";
			
			
			let o_combo_table = private_objs_global.o_combo_table;
			let s_schema_table_internal_names = private_objs_global.o_combo_table.getSelectedKey(); //collection
			let a_schema_table = s_schema_table_internal_names.split(NSAdvancedSearchQueryInterfacePrivate.combos.private_objs.CONSTS.COMBO_TABLE_KEY_SCHEMA_TABLE_SEPARATOR);
			let s_schema_internal_name = a_schema_table[0];
			let s_table_internal_name = a_schema_table[1];
			var a_comparisson_objects = private_objs_global.o_comparison_objects.a_comparisson_objects; //[Objs.ComparisonStruture]
			
			let s_col = o_combo_table.getSelectedKey();
			
			for(var i=0; i<a_comparisson_objects.length; i++ )
			{
				let o_cmp_stuct = a_comparisson_objects[i];
				let o_combo_field = o_cmp_stuct.o_combo_field;
				let o_combo_comparison_type = o_cmp_stuct.o_combo_comparison_type;
				let e_input_value = o_cmp_stuct.e_input_value;
					 
				let s_field_internal_name = o_combo_field.getSelectedKey(); //field
				let o_field_info = NSDataModelInfo.f_get_field_info(s_schema_internal_name, s_table_internal_name, s_field_internal_name);
				let s_field_type = (o_field_info!=null)? o_field_info.data_type: null;
				let b_is_catalogue = (o_field_info!=null )? o_field_info.is_enum : false;
				
				let b_comparison_type_needs_value;
				if(o_field_info != null)
				{
					let s_comparison_type_key = o_combo_comparison_type.getSelectedKey();
					// "is_null" and "is_not_null" don't use a value for comparison... 
					b_comparison_type_needs_value = private_objs_global.o_comparison_type.f_bool_comparison_type_needs_value(s_comparison_type_key);
				}
				
				var s_value = e_input_value.value;

				//if field is filled
				if( s_field_internal_name!=" " && b_comparison_type_needs_value)
				{
					// INPUT VALIDATION

					if(b_is_catalogue)
					{
					
					}
					else
					{
						var s_value_formated;
						if(NSDataTypes.f_type_is_any_text_type(s_field_type))
						{
							s_value_formated = '"' + s_value + '"';
						}
						else if( NSDataTypes.f_type_is_date_or_datetime(s_field_type) )
						{
							let b_date_is_valid = true;
							
							/*let s_date_untreated = NSDateDatetime.NSDate.f_get_value(e_input_value);
							let b_field_is_empty = (s_date_untreated == null || s_date_untreated == "")? true : false;*/
							// Empty dates ara considered invalid
							b_date_is_valid = NSDateDatetime.NSDate.f_date_is_valid(e_input_value);
							if(!b_date_is_valid)
							{
								b_all_input_is_valid = b_date_is_valid;
								s_error_message = "Date is not valid!"
							}
							
							//date is valid
							let s_ = NSDateDatetime.NSDate.f_get_value_as_db_date_string(e_input_value)
							//s_value_formated = 'date(' + s_ + ')';
							s_value_formated = s_;
						
						}
						else if( NSDataTypes.f_type_is_number_with_decimal_places(s_field_type) )
						{
							var s_ = s_value + "";
							var b_number_is_valid = this.f_s_is_number(s_);
							
							if(!b_number_is_valid)
							{
								b_all_input_is_valid = b_number_is_valid;
								s_error_message = "Number is not valid!"
							}

						}
						else if( NSDataTypes.f_type_is_integer_number(s_field_type) )
						{
							var s_ = s_value + "";
							var b_int_is_valid = this.f_s_is_int(s_);
							
							if(!b_int_is_valid)
							{
								b_all_input_is_valid = b_int_is_valid;
								s_error_message = "Integer is not valid!"
							}

						}
						else // Integer, Double, FeatureGeometry, MSFJoinField, FeatureGeometry
						{
							s_value_formated = s_value;
						}	
					}
						

				}

			}
			
			//Geometry Validation
			/*
			e_input_use_geo
			o_combo_geo_field
			o_combo_geo_area
			*/
			var e_input_use_geo = private_objs_global.e_input_use_geo;
			var o_combo_geo_area = private_objs_global.o_combo_geo_area;
			if(e_input_use_geo.checked == true)
			{
				var b_geometry_is_valid = true;
				
				var s_area_key = o_combo_geo_area.getSelectedKey();
				
				if(s_area_key == o_geo_struct.CONSTS.Geo_Area.trail.key)
				{
					var b_a_valid_polygon_is_drawn = NSToolDraw.f_draw_polygon_is_active_and_an_area_is_drawn();
					
					if(!b_a_valid_polygon_is_drawn)
					{
						b_geometry_is_valid = false;
						s_error_message = "Uma área válida deve ser desenhada."
					}
					
				}
				else //(s_area_key == o_geo_struct.CONSTS.Geo_Area.map.key)
				{
				
				}
				


				if(!b_geometry_is_valid)
				{
					b_all_input_is_valid = b_geometry_is_valid;
					//s_error_message = "Selected geometry is not valid!"
				}
			}
			
				
		
			o_message_struct.f_show_message(s_error_message);
			return b_all_input_is_valid;
		}		
	
	},
	
	o_geo_struct:
	{
		CONSTS: {
		
			Geo_Area: {
				map: { key: "map", desc: null },
				trail: {key: "trail", desc: null}
			},
			s_input_use_geo_id: "input_use_geo",
			s_sel_geo_field_id: "sel_geo_field",
			s_sel_geo_area_id: "sel_geo_area",
			
		},
		
		f_initialize: function()
		{
			var this_ = this;
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;

			//CONSTS definition
			this.CONSTS.Geo_Area.map.desc = NSPageLabels.f_get_label_text_by_internal_name("advanced_search_geometry_combobox_map");
			this.CONSTS.Geo_Area.trail.desc = NSPageLabels.f_get_label_text_by_internal_name("advanced_search_geometry_combobox_trail");
			
			var s_input_use_geo_id = this_.CONSTS.s_input_use_geo_id;
			var e_input_use_geo = document.getElementById(s_input_use_geo_id); //o_input_use_geo
			private_objs.e_input_use_geo = e_input_use_geo;
			
			e_input_use_geo.onclick = function(e)
			{
				this_.f_checkbox_value_change();
			}
			
			this_.f_initialize_combos();
			
		},
		
		f_initialize_combos: function ()
		{
			var this_ = this;
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			var s_sel_geo_field_id = this_.CONSTS.s_sel_geo_field_id;
			var s_sel_geo_area_id = this_.CONSTS.s_sel_geo_area_id;
			
			var f_onSelect_geo_field_CB = function(s_key)
			{
				//do nothing
			}
			var f_onSelect_area_CB = function(s_key)
			{
				this_.f_onSelect_area(s_key);
			}

			private_objs.o_combo_geo_field =  new NSCombos.objs.Combo(s_sel_geo_field_id, f_onSelect_geo_field_CB, [], null);
			private_objs.o_combo_geo_area =  new NSCombos.objs.Combo(s_sel_geo_area_id, f_onSelect_area_CB, [], null);
			
			this_.f_fill_combo_area();
			
		},
		
		f_fill_combo_geo_field: function(a_geo_field_desc, a_geo_field_key)
		{
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var o_combo_geo_field = private_objs.o_combo_geo_field;
			
			o_combo_geo_field.reset(a_geo_field_desc, a_geo_field_key);
		},
		
		f_fill_combo_area: function()
		{
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var CONSTS = this.CONSTS;
			var o_combo_geo_area = private_objs.o_combo_geo_area;
			
			var a_field_key = [CONSTS.Geo_Area.map.key, CONSTS.Geo_Area.trail.key];
			var a_field_desc = [CONSTS.Geo_Area.map.desc, CONSTS.Geo_Area.trail.desc];
			o_combo_geo_area.reset(a_field_desc, a_field_key);
		},
		
		f_onSelect_area: function (s_key)
		{
			
		},
		
		f_checkbox_value_change: function ()
		{
			var this_ = this;
			var private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			var s_input_use_geo_id = this_.CONSTS.s_input_use_geo_id;
			var e_input_use_geo = document.getElementById(s_input_use_geo_id); 
			let e_sel_geo_area = private_objs_global.e_sel_geo_area;


			let s_label_advanced_search_criteria_geometry_desc_first = NSPageLabels.f_get_label_text_by_internal_name("advanced_search_criteria_geometry_desc_first");
			let s_label_advanced_search_criteria_geometry_desc_and = NSPageLabels.f_get_label_text_by_internal_name("advanced_search_criteria_geometry_desc_and");

			if(e_input_use_geo.checked) {
				var message;
				if( private_objs_global.e_text_span.innerHTML != ""){
					message = "<span id='geo_span_2'> " + s_label_advanced_search_criteria_geometry_desc_and + " " + NSCombos.get_select_SelectedDesc(e_sel_geo_area) + "</span>";
				} else {
					message = "<span  id='geo_span_2'> " + s_label_advanced_search_criteria_geometry_desc_first + " " + NSCombos.get_select_SelectedDesc(e_sel_geo_area) + "</span>";
				}
				private_objs_global.e_geo_span.innerHTML += message;
			} else {
				private_objs_global.e_geo_span.innerHTML = "";
			}
				
		}
	
	},
	
	o_message_struct: 
	{
		f_show_message: function(s_message)
		{
			var private_objs = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			var e_span_as_query_messages = private_objs.e_span_as_query_messages;
			e_span_as_query_messages.innerHTML = "<b>" + s_message + "</b>";
		
		},
		f_clean_message: function()
		{
			this.f_show_message("");
		}
		
	},
	
	
	
	/*
	aux structs:
	*/
	o_sort: 
	{
		/*
			returns: 
			{
					a_key,
					a_desc
			}
		*/
		f_sort_array_key__and__array_desc: function(a_key_in, a_desc_in, b_int)
		{
			var o_array_of_obj_key_desc = this.o_array_of_obj_key_desc;
			var a_of_obj_with_desc_ = o_array_of_obj_key_desc.f_get_array(a_key_in, a_desc_in);
			
			this.f_sort_array_of_obj_with_desc_(a_of_obj_with_desc_, b_int);
			
			var o_res = o_array_of_obj_key_desc.f_get_a_key_and_a_desc(a_of_obj_with_desc_);
			
			return o_res;
			
			
		},
		
		/*
		array_obj_in -> 
						[
							{
								"desc": "description text"
								,...
							}
							, ...
						]
		*/
		f_sort_array_of_obj_with_desc_: function (array_obj_in, b_int)
		{
			var this_ = this;
			var f;
			if(b_int)
			{
				f = function(o_a, o_b){
					var a = o_a.desc;
					var b = o_b.desc;
					
					var i_a = (parseInt(a))? parseInt(a) : "Not a number";
					var i_b = (parseInt(b))? parseInt(b) : "Not a number";
					
					if(i_b == "Not a number")
					{
						return -1;
					}
					else if(i_a == "Not a number")
					{
						return 1;
					}
					else if(i_a>=i_b)
					{
						return 1;
					}
					else
					{
						return -1;
					}
				}
			}
			else
			{
				f = function(o_a, o_b){
					var s_a = o_a.desc + "";
					var s_b = o_b.desc + "";
				
					/*
					if(s_a>=s_b)
					{
						return 1;
					}
					else
					{
						return -1;
					}
					*/
					return this_.f_text_comparison(s_a, s_b);
				}
			
			}
			
			array_obj_in.sort(f);
		},
		o_array_of_obj_key_desc: 
		{
			f_get_array: function (a_key, a_desc)
			{
				var a_ = [];
				for(var i=0; i<a_key.length; i++)
				{
					var s_key_i = a_key[i];
					var s_desc_i = a_desc[i];
					a_.push({
						key: s_key_i,
						desc: s_desc_i,
					});
				}
				return a_;
			},
			/*
				returns: 
				{
						a_key,
						a_desc
				}
			*/
			f_get_a_key_and_a_desc: function(a_of_obj_key_desc)
			{
				var a_key = [];
				var a_desc = [];
				
				var a_ = a_of_obj_key_desc;
				for(var i=0; i<a_.length; i++)
				{
					var o_i = a_[i];
					var s_key = o_i.key;
					var s_desc = o_i.desc;
					
					a_key.push(s_key);
					a_desc.push(s_desc);
					
				}
				return {a_key: a_key, a_desc: a_desc};
			}
			
		},
		
		//treats content as text by default
		f_sort_array: function (array_in, b_int)
		{
			var this_ = this;
			
			var f;
			if(b_int)
			{
				f = function(a,b){
					var i_a = (parseInt(a))? parseInt(a) : "Not a number";
					var i_b = (parseInt(b))? parseInt(b) : "Not a number";
					
					if(i_b == "Not a number")
					{
						return -1;
					}
					else if(i_a == "Not a number")
					{
						return 1;
					}
					else if(i_a>=i_b)
					{
						return 1;
					}
					else
					{
						return -1;
					}
				}
			}
			else
			{
				f = function(a,b){
					var s_a = a + "";
					var s_b = b + "";
				
					/*
					if(s_a>=s_b)
					{
						return 1;
					}
					else
					{
						return -1;
					}
					*/
					return this_.f_text_comparison(s_a, s_b);
				}
			
			}
			
			array_in.sort(f);
		},
		f_text_comparison: function (s_1_param, s_2_param)
		{
			var f_format_s = function(s)
			{
				s = s.toLowerCase();

				s = NSFunctions.StringReplaceAll(s, "à","a");
				s = NSFunctions.StringReplaceAll(s, "á","a");
				s = NSFunctions.StringReplaceAll(s, "â","a");
				s = NSFunctions.StringReplaceAll(s, "ã","a");
				s = NSFunctions.StringReplaceAll(s, "è","e");
				s = NSFunctions.StringReplaceAll(s, "é","e");
				s = NSFunctions.StringReplaceAll(s, "ê","e");
				s = NSFunctions.StringReplaceAll(s, "ì","i");
				s = NSFunctions.StringReplaceAll(s, "í","i");
				s = NSFunctions.StringReplaceAll(s, "î","i");
				s = NSFunctions.StringReplaceAll(s, "ò","o");
				s = NSFunctions.StringReplaceAll(s, "ó","o");
				s = NSFunctions.StringReplaceAll(s, "ô","o");
				s = NSFunctions.StringReplaceAll(s, "õ","o");
				s = NSFunctions.StringReplaceAll(s, "ù","u");
				s = NSFunctions.StringReplaceAll(s, "ú","u");
				s = NSFunctions.StringReplaceAll(s, "û","u");
				
				return s;
			}
		
			var s_1 = f_format_s(s_1_param);
			var s_2 = f_format_s(s_2_param);
			
			var i_res = (s_1 > s_2)? 1 : -1;
			return i_res;	
			
		}
	},

	o_pagination_strut: 
	{
		CONSTS: {
			s_sel_pagination_elems_asq: "sel_pagination_elems_asq"
		},
		
		f_initialize: function()
		{
			var this_ = this;
			var private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			
			this_.f_initialize_combos();
		
		
		},
		
		/*
			returns max number of results per page
		*/
		f_get_i_constant_max_count: function()
		{
			//return 10;
			var private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var o_combo_pagination_elems = private_objs_global.o_combo_pagination_elems;
			
			var s_key = o_combo_pagination_elems.getSelectedKey();
			var i_constant_max_count = parseInt(s_key);
			
			return i_constant_max_count;
			
		},
		
		f_initialize_combos: function ()
		{
			var this_ = this;
			var private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			
			var s_sel_pagination_elems_asq = this_.CONSTS.s_sel_pagination_elems_asq;
			
			var f_onSelect_ = function(s_key)
			{
				//do nothing
			}
			private_objs_global.o_combo_pagination_elems =  new NSCombos.objs.Combo(s_sel_pagination_elems_asq, f_onSelect_, [], null);

			
			this_.f_fill_combo_elems_number();
			
		},
		f_fill_combo_elems_number: function()
		{
			var private_objs_global = NSAdvancedSearchQueryInterfacePrivate.private_objs;
			var o_combo_pagination_elems = private_objs_global.o_combo_pagination_elems;
			
			var a_geo_field_key = NSAdvancedSearchQueryInterfacePrivate.private_objs.settings.paging_values;
			var a_geo_field_desc = NSAdvancedSearchQueryInterfacePrivate.private_objs.settings.paging_labels;
			
			o_combo_pagination_elems.reset(a_geo_field_desc, a_geo_field_key);
		}

	},
	
	
	/*
	-------------------------------------------------------------------------------------------------------------------------
	classes:
	*/
	objs:
	{
		/*
		o_in = {
			id: String
			o_combo_field: {NSCombos.objs.Combo}, 
			o_combo_comparison_type: {NSCombos.objs.Combo}, 
			e_input_value: {dom element},
			o_combo_catalogue_value: {NSCombos.objs.Combo}, 
			
		}
		*/
		ComparisonStruture: function (o_in) 
		{
			this.id = o_in.id;
			this.o_combo_field = o_in.o_combo_field;
			this.o_combo_comparison_type = o_in.o_combo_comparison_type;
			this.e_input_value = o_in.e_input_value;
			this.o_combo_catalogue_value = o_in.o_combo_catalogue_value;
		},
		
		
		init: function()
		{
			
		}
		
	}
	
}